export const ENV: "prd" | "dev" | "local" =
  process.env.REACT_APP_IS_USING_LOCAL_SERVER === "TRUE"
    ? "local"
    : process.env.REACT_APP_IS_DEV === "TRUE"
    ? "dev"
    : "prd";

export const API_URL =
  ENV === "local"
    ? "http://localhost:5001/recopo-client-app-dev/asia-northeast1"
    : ENV === "dev"
    ? "https://asia-northeast1-recopo-client-app-dev.cloudfunctions.net"
    : "https://asia-northeast1-recopo-client-app.cloudfunctions.net";
